export default [
  {
    "readable": "Shqip",
    "key": "sq"
  },
  {
    "readable": "العربية",
    "key": "ar"
  },
  {
    "readable": "azərbaycan dili, تۆرکجه",
    "key": "az"
  },
  {
    "readable": "বাংলা",
    "key": "bn"
  },
  {
    "readable": "български език",
    "key": "bg"
  },
  {
    "readable": "català, valencià",
    "key": "ca"
  },
  {
    "readable": "中文 (Zhōngwén), 汉语, 漢語",
    "key": "zh"
  },
  {
    "readable": "čeština, český jazyk",
    "key": "cs"
  },
  {
    "readable": "dansk",
    "key": "da"
  },
  {
    "readable": "Nederlands, Vlaams",
    "key": "nl"
  },
  {
    "readable": "English",
    "key": "en"
  },
  {
    "readable": "Esperanto",
    "key": "eo"
  },
  {
    "readable": "eesti, eesti keel",
    "key": "et"
  },
  {
    "readable": "suomi, suomen kieli",
    "key": "fi"
  },
  {
    "readable": "français, langue française",
    "key": "fr"
  },
  {
    "readable": "Deutsch",
    "key": "de"
  },
  {
    "readable": "ελληνικά",
    "key": "el"
  },
  {
    "readable": "עברית",
    "key": "he"
  },
  {
    "readable": "हिन्दी, हिंदी",
    "key": "hi"
  },
  {
    "readable": "magyar",
    "key": "hu"
  },
  {
    "readable": "Bahasa Indonesia",
    "key": "id"
  },
  {
    "readable": "Gaeilge",
    "key": "ga"
  },
  {
    "readable": "Italiano",
    "key": "it"
  },
  {
    "readable": "日本語 (にほんご)",
    "key": "ja"
  },
  {
    "readable": "한국어",
    "key": "ko"
  },
  {
    "readable": "lietuvių kalba",
    "key": "lt"
  },
  {
    "readable": "latviešu valoda",
    "key": "lv"
  },
  {
    "readable": "Bahasa Melayu, بهاس ملايو‎",
    "key": "ms"
  },
  {
    "readable": "Norsk Bokmål",
    "key": "nb"
  },
  {
    "readable": "فارسی",
    "key": "fa"
  },
  {
    "readable": "język polski, polszczyzna",
    "key": "pl"
  },
  {
    "readable": "Português",
    "key": "pt"
  },
  {
    "readable": "Română, Moldovenească",
    "key": "ro"
  },
  {
    "readable": "русский",
    "key": "ru"
  },
  {
    "readable": "српски језик",
    "key": "sr"
  },
  {
    "readable": "Slovenčina, Slovenský jazyk",
    "key": "sk"
  },
  {
    "readable": "Slovenski jezik, Slovenščina",
    "key": "sl"
  },
  {
    "readable": "Español",
    "key": "es"
  },
  {
    "readable": "Svenska",
    "key": "sv"
  },
  {
    "readable": "ไทย",
    "key": "th"
  },
  {
    "readable": "Wikang Tagalog",
    "key": "tl"
  },
  {
    "readable": "Türkçe",
    "key": "tr"
  },
  {
    "readable": "Українська",
    "key": "uk"
  },
  {
    "readable": "اردو",
    "key": "ur"
  },
  {
    "readable": "Tiếng Việt",
    "key": "vi"
  }
]